import { useLinks } from '@hooks/use-links';
import { AboutSavingInfoPage } from '@pages/about-saving-info/about-saving-info-page';
import { ApplicantParentSuccessPage } from '@pages/applicant-parent-success/applicant-parent-success-page';
import { ApproverParentConsentPage } from '@pages/approver-parent-consent/approver-parent-consent-page';
import { ApproverParentSuccessPage } from '@pages/approver-parent-success/approver-parent-success-page';
import { EnterApproverParentInformationPage } from '@pages/enter-approver-parent-information/enter-approver-parent-information-page';
import { HowToCreateInfoPage } from '@pages/how-to-create-info/how-to-create-info-page';
import { NextStepPage } from '@pages/next-step/next-step-page';
import { OverviewPage } from '@pages/overview/overview-page';
import { OverviewOfSavingInfoPage } from '@pages/overview-of-saving-info/overview-of-saving-info-page';
import { PendingProcessPage } from '@pages/pending-process/pending-process-page';
import { StopPage } from '@pages/stop/stop-page';
import { SummaryPage } from '@pages/summary/summary-page';
import { Route, Routes } from 'react-router-dom';

export const ChildAccountRoutes = () => {
    const links = useLinks();

    return (
        <Routes>
            <Route path={'/'} element={<OverviewPage />} />
            <Route path={links.aboutSavingInfo.url} element={<AboutSavingInfoPage />} />
            <Route path={links.overviewOfSavingInfo.url} element={<OverviewOfSavingInfoPage />} />
            <Route path={links.howToCreateInfo.url} element={<HowToCreateInfoPage />} />
            <Route path={links.enterApproverParentInformation.url} element={<EnterApproverParentInformationPage />} />
            <Route path={links.applicantParentSummary.url} element={<SummaryPage />} />
            <Route path={`${links.applicantParentSuccess.url}/:processId`} element={<ApplicantParentSuccessPage />} />
            <Route path={`${links.applicantParentStop.url}/:processId`} element={<StopPage />} />
            <Route path={`${links.nextStep.url}/:processId`} element={<NextStepPage />} />
            <Route path={`${links.process.url}/:processId`} element={<PendingProcessPage />} />
            <Route path={links.approverParentConsent.url} element={<ApproverParentConsentPage />} />
            <Route path={`${links.approverParentSuccess.url}/:processId`} element={<ApproverParentSuccessPage />} />
        </Routes>
    );
};
